import { Component } from "react";
import Header, { IProps as IHeaderProps } from "../../Components/Layout/Header/Header";
import Sidebar from "../../Components/Layout/Sidebar/Sidebar";
import { appContext } from "../../AppContext";


class Unauthorised extends Component
{
    private labels = appContext().labels;

    public render(): JSX.Element
    {
        return (
            <div className="page-container" style={{ overflow: "hidden", display: "flex", backgroundColor: "var(--ui-background)" }}>
                <Sidebar {...this.props} />
                <div className="rightPanel">
                    <Header {...this.props as unknown as IHeaderProps} />
                    <div className="rightPanel-main-content">
                        <div className="redirectContainer">
                            <div className="title titleCenter">{this.labels.HubLabelUnauthorisedMessage}</div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



export default Unauthorised;
